/* ==========================================================================
   CHANNEL CANNA — shared behaviour                      assets/channel-canna.js
   Load with `defer` from layout/theme.liquid (after theme.js). No deps.

   1. Static / Clear picture toggle — [data-ch-static] buttons (header).
      State: html[data-static="on"|"off"]. Stored in localStorage
      `cc-static` (try/catch: private mode / blocked storage just means the
      default). The default comes from html[data-static-default] (printed by
      the header from settings.static_default, else "on"). The header's
      inline boot script applies the stored value before first paint; this
      file only wires the buttons. Emits `cc:static` {detail: {on: bool}}.
   2. Arrival — sections marked [data-ch-reveal] get .is-in when they enter
      the viewport (drives the title-card static burst and the process icon
      reels). A section is only "armed" (.is-armed) once the observer has
      confirmed it is off screen, so content is never hidden by this file.
   3. Dial nav — [data-ch-dial] links whose hash matches a section id on the
      page get .is-on while that section is in the middle of the viewport.
   Events listened to: shopify:section:load (theme editor).
   ========================================================================== */
(function () {
  'use strict';
  var root = document.documentElement;
  var KEY = 'cc-static';
  var arr = function (l) { return Array.prototype.slice.call(l || []); };

  /* ── 1. Static / Clear ─────────────────────────────────────────────── */
  function current() { return root.getAttribute('data-static') === 'off' ? 'off' : 'on'; }
  function paint(state) {
    arr(document.querySelectorAll('[data-ch-static]')).forEach(function (b) {
      b.setAttribute('aria-pressed', state === 'on' ? 'true' : 'false');
      b.hidden = false; /* ships hidden: without JS it could do nothing */
    });
  }
  function setStatic(state, persist) {
    state = state === 'off' ? 'off' : 'on';
    root.setAttribute('data-static', state);
    if (persist) { try { localStorage.setItem(KEY, state); } catch (e) {} }
    paint(state);
    try { document.dispatchEvent(new CustomEvent('cc:static', { detail: { on: state === 'on' } })); } catch (e) {}
  }
  function bootStatic() {
    if (!root.hasAttribute('data-static')) {
      var s = null;
      try { s = localStorage.getItem(KEY); } catch (e) {}
      if (s !== 'on' && s !== 'off') s = root.getAttribute('data-static-default') === 'off' ? 'off' : 'on';
      root.setAttribute('data-static', s);
    }
    paint(current());
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ch-static]') : null;
    if (!b) return;
    setStatic(current() === 'on' ? 'off' : 'on', true);
  });
  window.ccStatic = { get: current, set: function (s) { setStatic(s, true); } };

  /* ── 2. Arrival ────────────────────────────────────────────────────── */
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var s = en.target;
        if (en.isIntersecting) { s.classList.add('is-in'); io.unobserve(s); }
        else if (!s.classList.contains('is-in')) s.classList.add('is-armed');
      });
    }, { threshold: 0, rootMargin: '0px 0px -15% 0px' });
  }
  function watch(scope) {
    arr((scope || document).querySelectorAll('[data-ch-reveal]')).forEach(function (s) {
      if (s.__chWatched) return;
      s.__chWatched = true;
      if (io) io.observe(s); else s.classList.add('is-in');
    });
  }

  /* ── 3. Dial nav ───────────────────────────────────────────────────── */
  var dialIO = null;
  function dial() {
    var links = arr(document.querySelectorAll('[data-ch-dial] a[href*="#"]'));
    if (!links.length || !('IntersectionObserver' in window)) return;
    var targets = [];
    links.forEach(function (a) {
      var url;
      try { url = new URL(a.href, location.href); } catch (e) { return; }
      if (url.pathname !== location.pathname || !url.hash) return;
      var t = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (t && targets.indexOf(t) < 0) targets.push(t);
    });
    if (!targets.length) return;
    if (dialIO) dialIO.disconnect();
    dialIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var id = '#' + en.target.id;
        links.forEach(function (a) {
          var on = a.hash === id && a.pathname === location.pathname;
          a.classList.toggle('is-on', on);
          if (on && a.closest('.ch-strip') && a.scrollIntoView) {
            var strip = a.closest('.ch-strip');
            strip.scrollLeft = a.offsetLeft - (strip.clientWidth - a.offsetWidth) / 2;
          }
        });
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    targets.forEach(function (t) { dialIO.observe(t); });
  }


  /* -- 4. Tune-in + knob (owner 2026-10-08) -------------------------------
     Each channel section "tunes in" when you arrive: ~650ms of static with
     a rolling bar and an on-screen channel tag, then the picture. Fires on
     scroll arrival (once per section), on a dial-link click and on the
     header knob. Reduced motion or Static off = no burst. Overlay only:
     never hides content or takes pointer events. */
  function stillMode() {
    return root.getAttribute('data-static') === 'off' ||
      (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  var chans = [];
  function esc(s) { return String(s || '').replace(/[<>&"]/g, ''); }
  function channels() {
    var nav = document.querySelector('[data-ch-dial]');
    var out = [];
    if (!nav) return out;
    arr(nav.querySelectorAll('a[href*="#"]')).forEach(function (a) {
      var url; try { url = new URL(a.href, location.href); } catch (e) { return; }
      if (url.pathname !== location.pathname || !url.hash) return;
      var el = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (!el) return;
      var b = a.querySelector('b'), s = a.querySelector('span');
      out.push({ el: el, num: b ? b.textContent.trim() : '', label: s ? s.textContent.trim() : a.textContent.trim() });
    });
    return out;
  }
  function tune(ch) {
    if (!ch || stillMode()) return;
    var el = ch.el;
    arr(document.querySelectorAll('body > .ch-tune')).forEach(function (x) { x.remove(); });
    var o = document.createElement('div');
    o.className = 'ch-tune';
    o.setAttribute('aria-hidden', 'true');
    o.innerHTML = '<span class="ch-tune__snow"></span><span class="ch-tune__bar"></span><span class="ch-tune__osd">' +
      (ch.num ? '<b>' + esc(ch.num) + '</b>' : '') + esc(ch.label) + '</span>';
    document.body.appendChild(o);
    setTimeout(function () { if (o.parentNode) o.parentNode.removeChild(o); }, 900);
  }
  var tuneIO = null, currentCh = -1;
  function turnKnob(i) {
    var n = chans.length || 6;
    arr(document.querySelectorAll('[data-ch-knob] .ch-knob__face')).forEach(function (g) {
      g.style.setProperty('--ch-knob', (i * (360 / n)) + 'deg');
    });
  }
  function tuneSetup() {
    chans = channels();
    if (!chans.length || !('IntersectionObserver' in window)) return;
    if (tuneIO) tuneIO.disconnect();
    tuneIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var c = chans.filter(function (x) { return x.el === en.target; })[0];
        if (!c) return;
        if (!en.isIntersecting) { if (!c.seen) c.armed = true; return; }
        currentCh = chans.indexOf(c); turnKnob(currentCh);
        if (c.armed && !c.seen) { c.seen = true; tune(c); }
        else c.seen = true;
      });
    }, { rootMargin: '-35% 0px -45% 0px' });
    chans.forEach(function (c) { tuneIO.observe(c.el); });
    arr(document.querySelectorAll('[data-ch-knob]')).forEach(function (k) { k.hidden = false; });
  }
  function goTo(i) {
    if (!chans.length) return;
    i = (i + chans.length) % chans.length;
    var c = chans[i];
    currentCh = i; turnKnob(i); c.seen = true;
    var smooth = !stillMode();
    var off = parseInt(getComputedStyle(root).getPropertyValue('--ki-header-h'), 10) || 64;
    var top = c.el.getBoundingClientRect().top + window.pageYOffset - off - 12;
    window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
    tune(c);
  }
  document.addEventListener('click', function (e) {
    var k = e.target && e.target.closest ? e.target.closest('[data-ch-knob]') : null;
    if (k) { e.preventDefault(); goTo(currentCh + 1); return; }
    var a = e.target && e.target.closest ? e.target.closest('[data-ch-dial] a[href*="#"]') : null;
    if (!a || !chans.length) return;
    var i = -1;
    chans.forEach(function (c, j) { if (a.hash === '#' + c.el.id && a.pathname === location.pathname) i = j; });
    if (i < 0) return;
    e.preventDefault();
    if (history.replaceState) history.replaceState(null, '', a.hash);
    goTo(i);
  });
  document.addEventListener('keydown', function (e) {
    var k = e.target && e.target.closest ? e.target.closest('[data-ch-knob]') : null;
    if (!k) return;
    if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { e.preventDefault(); goTo(currentCh + 1); }
    if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { e.preventDefault(); goTo(currentCh - 1); }
  });


  /* -- 5. Curtain call (Tonight's cast) ------------------------------------
     [data-ch-curtain] gets a closed engraved curtain when it arrives from
     off screen, which parts and lifts in ~1.3s. Built by JS only, so no-JS,
     reduced motion and Static off simply show the card. */
  var curtIO = null;
  function curtains(scope) {
    var els = arr((scope || document).querySelectorAll('[data-ch-curtain]'));
    if (!els.length || !('IntersectionObserver' in window)) return;
    if (!curtIO) curtIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var el = en.target;
        if (!en.isIntersecting) { if (!el.__curtSeen) el.__curtArmed = true; return; }
        if (el.__curtSeen) return;
        el.__curtSeen = true; curtIO.unobserve(el);
        if (!el.__curtArmed || stillMode()) return;
        var o = document.createElement('div');
        o.className = 'ch-curtain'; o.setAttribute('aria-hidden', 'true');
        o.innerHTML = '<span class="ch-curtain__l" style="background-image:url(' + el.dataset.l + ')"></span>' +
          '<span class="ch-curtain__r" style="background-image:url(' + el.dataset.r + ')"></span>' +
          '<span class="ch-curtain__t" style="background-image:url(' + el.dataset.t + ')"></span>';
        el.appendChild(o);
        requestAnimationFrame(function () { requestAnimationFrame(function () { o.classList.add('is-open'); }); });
        setTimeout(function () { if (o.parentNode) o.parentNode.removeChild(o); }, 2500);
      });
    }, { rootMargin: '0px 0px -55% 0px' });
    els.forEach(function (el) { if (!el.__curtWatch) { el.__curtWatch = true; curtIO.observe(el); } });
  }

  function init(scope) { bootStatic(); watch(scope); dial(); tuneSetup(); curtains(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();

/* -- 6. The remote (owner 2026-10-08) ----------------------------------------
   The fixed bar on phones and tablets: Shop, plus channel down/up that flips
   the TV in place. It never scrolls the page while the TV is on screen; if
   the TV is scrolled away, the first press brings it back into view.
   7. Lineup photos: tapping a can photo picks that formula. */
(function () {
  function tvEl() { return document.querySelector('[data-channel-tv]'); }
  function api() { var el = tvEl(); return el && el.channelTV; }
  function off() { var i = document.querySelector('.ch-tv__inner[data-ch-off]'); return i ? parseInt(i.getAttribute('data-ch-off'), 10) || 0 : 0; }
  function name(n) {
    var el = tvEl(); if (!el) return '';
    var t = el.querySelectorAll('[data-ch-panel]')[n - 1];
    var h = t && t.querySelector('.ch-panel__title');
    return h ? h.textContent.trim() : '';
  }
  function paint() {
    var tv = api(); if (!tv) return;
    var n = tv.current || 1, shown = n - off();
    var num = document.querySelector('[data-cc-remote-num]'), nm = document.querySelector('[data-cc-remote-name]');
    if (num) num.textContent = shown > 0 ? 'CH ' + (shown < 10 ? '0' : '') + shown : 'CH';
    if (nm) nm.textContent = shown > 0 ? (name(n) || 'Now showing') : 'Change the channel';
  }
  function step(d) {
    var tv = api(), el = tvEl(); if (!tv || !el) return;
    var count = tv.count || 1, o = off(), first = o + 1;
    var n = (tv.current || 1) + d;
    if (n > count) n = first;
    if (n < first) n = count;
    var r = el.querySelector('.ch-tv__tv') ? el.querySelector('.ch-tv__tv').getBoundingClientRect() : el.getBoundingClientRect();
    var onScreen = r.bottom > 80 && r.top < window.innerHeight - 80;
    if (!onScreen) {
      var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - 70), behavior: still ? 'auto' : 'smooth' });
    }
    tv.go(n);
  }
  function boot() {
    var ch = document.querySelector('[data-cc-remote-ch]');
    if (ch && api()) { ch.hidden = false; document.documentElement.classList.add('has-remote-ch'); paint(); }
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-cc-remote-step]') : null;
    if (b) { e.preventDefault(); step(parseInt(b.getAttribute('data-cc-remote-step'), 10) || 1); return; }
    var fig = e.target && e.target.closest ? e.target.closest('.lnx-fig[data-formula]') : null;
    if (!fig) return;
    var panel = fig.closest('.lnx-panel') || fig.parentElement;
    var btn = panel && panel.querySelector('[data-lnx-choice][data-formula="' + fig.getAttribute('data-formula') + '"]');
    if (btn && btn.getAttribute('aria-pressed') !== 'true') btn.click();
  });
  document.addEventListener('channel-tv:change', paint);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); });
  else setTimeout(boot, 0);
  window.addEventListener('load', boot);
})();

/* -- 8. The reel: sprockets run with the scroll, the label of the frame that
   comes on air shows for a moment, and the strip steps aside for the footer. */
(function () {
  var reel = document.querySelector('[data-ch-reel]');
  if (!reel) return;
  var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ticking = false;
  function frame() {
    ticking = false;
    if (!still) reel.style.setProperty('--reel-shift', Math.round(window.pageYOffset * 0.35) % 13 + 'px');
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
  var last = null, timer = 0;
  if ('MutationObserver' in window) new MutationObserver(function () {
    var on = reel.querySelector('a.is-on');
    if (!on || on === last) return;
    if (last) last.classList.remove('is-flash');
    last = on; on.classList.add('is-flash');
    clearTimeout(timer); timer = setTimeout(function () { on.classList.remove('is-flash'); }, 1600);
  }).observe(reel, { subtree: true, attributes: true, attributeFilter: ['class'] });
  var foot = document.querySelector('footer, .shopify-section-footer, #shopify-section-footer');
  if (foot && 'IntersectionObserver' in window) new IntersectionObserver(function (en) {
    reel.classList.toggle('is-away', en[en.length - 1].isIntersecting);
  }, { rootMargin: '0px 0px -30% 0px' }).observe(foot);
})();

/* -- 9. Phones (owner 2026-10-08): arrows beside the TV flip the story; the
   Channels film strip in the header moves around the site. */
(function () {
  var arr = function (l) { return Array.prototype.slice.call(l || []); };
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-tv-step]') : null;
    if (!a) return;
    var el = a.closest('[data-channel-tv]'), tv = el && el.channelTV;
    if (!tv) return;
    e.preventDefault();
    el.classList.add('is-touched');
    if (parseInt(a.getAttribute('data-tv-step'), 10) < 0) tv.prev(); else tv.next();
  });

  var box = document.querySelector('[data-kh-ch]');
  if (!box) return;
  var btn = box.querySelector('[data-kh-ch-btn]'), list = box.querySelector('.kh-ch__list'), now = box.querySelector('[data-kh-ch-now]');
  var base = now ? now.textContent : 'Channels';
  function open(on) {
    list.hidden = !on; btn.setAttribute('aria-expanded', String(on)); box.classList.toggle('is-open', on);
  }
  btn.addEventListener('click', function () { open(list.hidden); });
  list.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('a')) setTimeout(function () { open(false); }, 0); });
  document.addEventListener('click', function (e) { if (!list.hidden && !box.contains(e.target)) open(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !list.hidden) { open(false); btn.focus(); } });
  function paint() {
    var on = list.querySelector('a.is-on');
    if (!now) return;
    if (on) { var b = on.querySelector('b'); now.textContent = b ? b.textContent.trim() : base; }
    else now.textContent = base;
  }
  if ('MutationObserver' in window) new MutationObserver(paint).observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });
})();

/* -- 10. Header Shop chooser: one open at a time; closes on outside click / Esc. */
(function () {
  var picks = Array.prototype.slice.call(document.querySelectorAll('[data-kh-pick]'));
  if (!picks.length) return;
  picks.forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) picks.forEach(function (o) { if (o !== d) o.open = false; }); });
  });
  document.addEventListener('click', function (e) { picks.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') picks.forEach(function (d) { if (d.open) { d.open = false; d.querySelector('summary').focus(); } }); });
})();

/* -- 11. Channels on every page (owner 2026-10-08). On pages other than home,
   the page's own channel tabs ("Channel 2 • The lineup") become an "On this
   page" list at the top of the Channels strip, and on desktop a film reel
   down the left edge, both lighting up as you scroll. Home channels follow. */
(function () {
  var box = document.querySelector('[data-kh-ch-away]');
  var main = document.querySelector('main');
  if (!main) return;
  var re = /^\s*channel\s*(\d+)\s*[•·\-–:]\s*(.+?)\s*$/i;
  var seen = {}, items = [];
  Array.prototype.slice.call(main.querySelectorAll('p, span, div, h2, h3')).forEach(function (el) {
    if (el.children.length) return;
    var m = re.exec(el.textContent || '');
    if (!m || seen[m[1]]) return;
    var sec = el.closest('.shopify-section') || el.closest('section');
    if (!sec) return;
    seen[m[1]] = 1;
    if (!sec.id) sec.id = 'ch-' + m[1];
    items.push({ n: m[1], label: m[2].replace(/\s+/g, ' '), el: sec });
  });
  if (!items.length) return;
  items.sort(function (a, b) { return a.n - b.n; });
  function link(it, cls) {
    var a = document.createElement('a');
    a.href = '#' + it.el.id; if (cls) a.className = cls;
    a.innerHTML = '<b>CH' + it.n + '</b><span></span>';
    a.querySelector('span').textContent = it.label;
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var off = 96, top = it.el.getBoundingClientRect().top + window.pageYOffset - off;
      var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: top, behavior: still ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', '#' + it.el.id);
    });
    it.links = (it.links || []).concat(a);
    return a;
  }
  /* phones/tablets: Channels strip */
  if (box) {
    var list = box.querySelector('.kh-ch__list');
    if (list) {
      var head = document.createElement('p'); head.className = 'kh-ch__group kh-ch__group--here'; head.textContent = 'Now playing: ' + (box.getAttribute('data-page-name') || 'this page');
      var home = document.createElement('p'); home.className = 'kh-ch__group'; home.textContent = 'Home: the Canna Coffee story';
      var frag = document.createDocumentFragment();
      frag.appendChild(head);
      items.forEach(function (it) { frag.appendChild(link(it)); });
      list.insertBefore(frag, list.firstChild);
      box.hidden = false;
    }
  }
  /* desktop: a film reel for this page */
  if (!document.querySelector('[data-ch-reel]')) {
    var reel = document.createElement('nav');
    reel.className = 'ch-reel'; reel.setAttribute('aria-label', 'Channels on this page'); reel.setAttribute('data-ch-reel-page', '');
    reel.innerHTML = '<span class="ch-reel__cap" aria-hidden="true">CH</span>';
    items.forEach(function (it) { reel.appendChild(link(it)); });
    document.body.appendChild(reel);
    document.documentElement.classList.add('has-page-reel');
    var foot = document.querySelector('#shopify-section-footer, footer');
    if (foot && 'IntersectionObserver' in window) new IntersectionObserver(function (en) {
      reel.classList.toggle('is-away', en[en.length - 1].isIntersecting);
    }, { rootMargin: '0px 0px -30% 0px' }).observe(foot);
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        items.forEach(function (it) { (it.links || []).forEach(function (a) { a.classList.toggle('is-on', it.el === e.target); }); });
        var cur = items.filter(function (it) { return it.el === e.target; })[0];
        var now = box && box.querySelector('[data-kh-ch-now]');
        if (now && cur) now.textContent = 'CH' + cur.n;
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    items.forEach(function (it) { io.observe(it.el); });
  }
})();
